define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ParticipantService = void 0;
    class ParticipantService {
        constructor(httpRequest) {
            this.httpRequest = httpRequest;
        }
        update(roomId, requestBody) {
            return this.httpRequest.request({
                method: 'PATCH',
                path: `/room/${roomId}/participant`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
        joinAsSpeaker(roomId, requestBody, upgrade) {
            return this.httpRequest.request({
                method: 'POST',
                path: `/room/${roomId}/participant/speaker`,
                query: {
                    'upgrade': upgrade,
                },
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
        joinAsViewer(roomId, requestBody) {
            return this.httpRequest.request({
                method: 'POST',
                path: `/room/${roomId}/participant/viewer`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
        viewerUpdate(roomId, requestBody) {
            return this.httpRequest.request({
                method: 'PATCH',
                path: `/room/${roomId}/participant/viewer`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
        dial(roomId, requestBody) {
            return this.httpRequest.request({
                method: 'POST',
                path: `/room/${roomId}/participant/dial`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
        update1(roomId, requestBody) {
            return this.httpRequest.request({
                method: 'POST',
                path: `/room/${roomId}/participant/subscriptions`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    500: `Internal Server Error`,
                },
            });
        }
    }
    exports.ParticipantService = ParticipantService;
});
